// prismal/blocks/timeline/src/view.js
//
// Plain DOM JS on purpose - no React, no @prismal/react, and this block is
// never registered in blocks/shared/view.js's parserMap. Every interaction
// that matters (hover-to-expand, dim-the-rest, shapes) already works from
// _timeline.scss alone; this file only adds two progressive enhancements:
// dismissing the "drag to explore" hint after first interaction, and
// letting a mouse user pan by dragging anywhere in the scroller.
import './view.scss';
import { attachTimelineTooltip } from './tooltip';

const HINT_STORAGE_KEY = 'prismal-timeline-hint-dismissed';

const dismissHint = (root) => {
    root.classList.add('prismal-timeline--hint-dismissed');
    try {
        window.localStorage.setItem(HINT_STORAGE_KEY, '1');
    } catch (e) {
        // Storage may be unavailable (private mode, disabled cookies) - the
        // hint simply won't persist across page loads, which is harmless.
    }
};

const enableDragToPan = (scroller) => {
    let isDown = false;
    let startX = 0;
    let startScroll = 0;

    scroller.addEventListener('pointerdown', (event) => {
        if (event.button !== 0 || event.target.closest('.prismal-timeline-node')) {
            return;
        }
        isDown = true;
        startX = event.clientX;
        startScroll = scroller.scrollLeft;
        scroller.classList.add('is-dragging');
    });

    const stop = () => {
        isDown = false;
        scroller.classList.remove('is-dragging');
    };

    scroller.addEventListener('pointermove', (event) => {
        if (!isDown) {
            return;
        }
        scroller.scrollLeft = startScroll - (event.clientX - startX);
    });

    scroller.addEventListener('pointerup', stop);
    scroller.addEventListener('pointerleave', stop);
};

const initTimeline = () => {
    document.querySelectorAll('.wp-block-prismal-timeline').forEach((root) => {
        const scroller = root.querySelector('.prismal-timeline-scroller');
        if (!scroller) {
            return;
        }

        let dismissed = false;
        try {
            dismissed = window.localStorage.getItem(HINT_STORAGE_KEY) === '1';
        } catch (e) {
            dismissed = false;
        }
        if (dismissed) {
            root.classList.add('prismal-timeline--hint-dismissed');
        } else {
            const onFirstInteraction = () => {
                dismissHint(root);
                scroller.removeEventListener('wheel', onFirstInteraction);
                scroller.removeEventListener('pointerdown', onFirstInteraction);
                scroller.removeEventListener('touchstart', onFirstInteraction);
            };
            scroller.addEventListener('wheel', onFirstInteraction, { passive: true });
            scroller.addEventListener('pointerdown', onFirstInteraction);
            scroller.addEventListener('touchstart', onFirstInteraction, { passive: true });
        }

        enableDragToPan(scroller);
        attachTimelineTooltip(root);
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTimeline);
} else {
    initTimeline();
}
